export const scheduleAssistantTranslationsEn = {
  alertsActiveExplanation: 'Collision alerts are active',
  alertsInactiveExplanation: 'Collision alerts are inactive',
  collisionDetails: 'Collision details',
  collisionsText: '{count} Collisions',
  helpLinkText: 'Learn more about collisions',
  howToAccordionTitle: 'How to activate collision alerts',
  howToLine1:
    'Set {thresholds}, to enable resource collision alerts as soon as a {maximum} value passes that threshold.',
  howToLine2:
    '{active} as soon as you set your threshold and workers have been added in the relevant schedule activities.',
  howToLine3:
    '{inactive} if there is no threshold set, or workers have not been added to the relevant schedule activities.',
  learnMoreAboutThresholdsButtonText: 'Learn more about setting thresholds',
  maximumLabel: 'Maximum',
  maximumTooltip:
    'The {maximum} is the highest number of workers this company will have on this project on the same day.',
  noCollisionsMessageText: 'No collisions detected are detected in this project.',
  noCollisionsMessageTitle: 'You are all set!',
  noContributorGroupsSetup: 'There are no teams or companies set up yet',
  noContributorGroupsSetupLink: 'Setup teams and companies',
  noWorkersAddedChipText: 'No workers added',
  resourceAlertSettingsSubtitle:
    'Set thresholds to enable collision alerts from your schedule assistant.',
  resourceAlertSettingsTitle: 'Resource alert settings',
  scheduleAssistantTitle: 'Schedule Assistant',
  siteThresholdSectionTitle: 'Site threshold',
  statusHeaderCollisionsCount: '{count} Collisions',
  statusLabel: 'STATUS',
  teamAndCompanyThresholdsSectionTitle: 'Team and company thresholds',
  thresholdExceeded: 'Threshold exceeded',
  thresholdExceededSite: 'Site threshold exceeded',
  thresholdsLabel: 'Threshold | Thresholds',
  thresholdsTooltip:
    '{thresholds} determine the maximum number of workers that a site can accommodate, or that a company or team is able to provide.',
  workerThresholdExceededAlertText:
    'The threshold of 1 worker is being exceeded on {date}. | The threshold of {count} workers is being exceeded on {date}.',
  workerThresholdsSummaryLabel: 'Worker threshold | Worker thresholds',
};
